<script lang="ts" setup>
defineProps({
  flush: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    class="text-xs leading-5 text-slate-400"
    :class="{ 'mb-1': ! flush }"
  >
    <slot />
  </div>
</template>
